import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    title: 'Bloquear en redes no fue suficiente:',
    desc: "Porque sigues haciendo 'contacto cero físico' pero mantienes un 'contacto mental' obsesivo."
  }, {
    title: 'La terapia convencional es lenta:',
    desc: 'Necesitas herramientas de contención para la crisis de ansiedad de esta noche, no solo hablar del pasado.'
  }, {
    title: "Intentar 'distraerte':",
    desc: 'Solo entierra el dolor temporalmente, pero el vacío vuelve a aparecer en cuanto te quedas a solas.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-dark" data-id="element-15">
      <div className="max-w-2xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h3 className="font-serif text-2xl md:text-3xl text-white mb-10 text-center" data-id="element-18">
            Por qué lo que has intentado no funciona
          </h3>
        </FadeIn>
        <div className="space-y-6" data-id="element-19">
          {approaches.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-20">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-brand-slate/50 border border-white/5 hover:border-brand-danger/20 transition-colors" data-id="element-21">
                <XCircle className="w-6 h-6 text-brand-danger flex-shrink-0 mt-1 opacity-80" data-id="element-22" />
                <div data-id="element-23">
                  <h4 className="text-white font-semibold text-lg mb-2" data-id="element-24">
                    {item.title}
                  </h4>
                  <p className="text-brand-text/80 leading-relaxed" data-id="element-25">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}